import { useTranslation } from 'next-i18next';
import { type TemplateAiTutor } from '@/shared/components/Chatbot';
import { AiChatMessage, UserChatMessage } from '@/shared/components/Chatbot/ChatMessage';
import { Button } from '@/ui_v3';
interface Props {
  aiTutor: TemplateAiTutor;
  onConfirmAiTutor?: (aiTutor: TemplateAiTutor) => void;
  showConfirmButton?: boolean;
}
export const AiTutorDetail = ({
  aiTutor,
  onConfirmAiTutor,
  showConfirmButton = true
}: Props) => {
  const {
    t
  } = useTranslation(['build']);
  return <section className="relative flex size-full flex-col gap-md bg-violet-50 px-3xs py-lg mobile-lg:px-md mobile-lg:py-xl" data-sentry-component="AiTutorDetail" data-sentry-source-file="AiTutorDetail.tsx">
      <UserChatMessage className="bg-violet-100" content={aiTutor.userExample} data-sentry-element="UserChatMessage" data-sentry-source-file="AiTutorDetail.tsx" />
      <AiChatMessage className="bg-white" avatarSrc={aiTutor.previewAvatarSrc} content={aiTutor.aiExample} data-sentry-element="AiChatMessage" data-sentry-source-file="AiTutorDetail.tsx" />

      <div className="absolute bottom-0 left-0 z-[2] flex w-full flex-col">
        <div className="h-[50px]" style={{
        background: 'linear-gradient(180deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.9))'
      }} />
        <div className="flex flex-col gap-md bg-white px-md pb-lg pt-sm mobile-lg:px-lg">
          <div className="flex flex-col items-center">
            <div className="rounded-md bg-violet-50 p-xs">
              <img className="size-[34px]" src={aiTutor.chatAvatarSrc} alt={aiTutor.name} width={34} height={34} />
            </div>
            <h3 className="mb-4xs mt-xs text-heading-md-bold">
              {aiTutor.name}
            </h3>
            <p className="text-body-sm-medium text-alternative">
              “{aiTutor.catchphrase}”
            </p>
          </div>
          <p className="rounded-md bg-neutral px-lg py-md text-body-sm-medium">
            {aiTutor.descriptions.join('\n')}
          </p>
          {showConfirmButton ? <Button className="w-full" intent="strong" size="lg" onClick={() => onConfirmAiTutor?.(aiTutor)}>
              {t('build:aiTutorDetail.selectButton')}
            </Button> : null}
        </div>
      </div>
    </section>;
};